<template>
    <div class="h-full w-full">
        <template v-if="article">
            <component
                :is="articleComponent"
                :article="article"
                :block="block"
                :articlelabel="articleLabel"
                :articleicon="articleIcon"
            />
        </template>
        <slot
            v-else-if="loading"
            name="loading"
        />
        <slot
            v-else
            name="empty"
        />
    </div>
</template>

<script setup>
    defineProps({
        article: Object,
        block: Object,
        loading: Boolean,
    })

    const articleLabel = 'News'
    const articleIcon = 'newspaper'
    const articleComponent = defineAsyncComponent(() => import('./article.async.vue'))
</script>
